import React from 'react';

import { useTranslation } from 'react-i18next';

interface ConnectionStatusProps {
  status: string;
}

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({
  status,
}) => {
  const { t } = useTranslation('pleri/chat');
  if (status === 'OPEN') {
    return null;
  }

  return (
    <div className="bg-yellow-50 px-4 py-2 text-sm text-yellow-800 dark:bg-yellow-950">
      {status === 'CONNECTING'
        ? t('connecting')
        : t('connectionLostReconnecting')}
    </div>
  );
};
